import React from 'react';
import './noDataFoundComponent.css';
import PropTypes from 'prop-types';
import nodataImg from '../../assests/images/nodata.png';

const NoDataFoundComponent = ({ text }) => {
  return (
    <div className='noDataDiv'>
      <img className='noDataImg' src={nodataImg} alt='noDataImg' />
      <div className='report-nodata'>{text}</div>
    </div>
  );
};

NoDataFoundComponent.propTypes = {
  text: PropTypes.string.isRequired,
};

export default NoDataFoundComponent;
